import React from "react";
import HotspotWithTabMenu from "../../react-components/hotspot-with-tab-menu";
import HotspotContainer from "../../sections/hotspot-container";

const getCoordinatesPix = str => {
  if (str) {
    let pixs = str.split(",");
    return [parseFloat(pixs[0]), parseFloat(pixs[1])];
  }
  return;
};

const Hotspot = props => {
  let { fields } = props;
  if (!fields) return null;

  const textContent = {
    heading: {
      text: fields.headingBody,
      html: fields.headingBody,
      type: fields.headingType,
      typographyClass: "type-h1"
    },
    body: fields.body && fields.body.value
  };

  const initialTab =
    fields.multipleTags.length &&
      fields.selectedTabIndex.value < fields.multipleTags.length
      ? fields.selectedTabIndex.value
      : 0;

  const tabMenu = {
    items: [],
    selectedTabIndex: 0
  };

  const overallSettings = {
    gridType:
      fields.gridType &&
      fields.gridType.fields &&
      fields.gridType.fields.phrase &&
      fields.gridType.fields.phrase.value,
    componentPadding: {
      top:
        fields.paddingAboveTop &&
        fields.paddingAboveTop.fields &&
        fields.paddingAboveTop.fields.phrase &&
        fields.paddingAboveTop.fields.phrase.value,
      bottom:
        fields.paddingAboveBottom &&
        fields.paddingAboveBottom.fields &&
        fields.paddingAboveBottom.fields.phrase &&
        fields.paddingAboveBottom.fields.phrase.value
    },
    backgroundColor:
      fields.backgroundColor &&
      fields.backgroundColor.fields &&
      fields.backgroundColor.fields.phrase &&
      fields.backgroundColor.fields.phrase.value,
    alignContent:
      fields.alignment &&
      fields.alignment.fields &&
      fields.alignment.fields.phrase &&
      fields.alignment.fields.phrase.value
  };

  const multipleHotspotsWithTabMenu = [];
  fields.multipleTags &&
    fields.multipleTags.forEach((item, index) => {
      let itemFields = item.fields;
      if (!itemFields) return;

      // menu data
      let label = itemFields.label && itemFields.label.value;
      let tabItem = {
        label: label,
        value: label,
        options: []
      };
      if (fields.selectedTabIndex && fields.selectedTabIndex.value === label) {
        tabMenu.selectedTabIndex = index;
      }

      // multiple data
      let multipleItem = {
        tab: label,
        options: []
      };

      item.fields &&
        item.fields.options &&
        item.fields.options.forEach((opt, ox) => {
          let optionFields = opt.fields;
          if (!optionFields) return;

          let optLabel = optionFields.label && optionFields.label.value;
          if (item.fields.options.length > 1) {
            tabItem.options.push({
              label: optLabel,
              value: optLabel
            });
          }

          let multipleOption = {
            label: optLabel,
            images: []
          };

          optionFields.imageItems &&
            optionFields.imageItems.forEach((imgItem, imgIndex) => {
              let imgFields = imgItem.fields;
              if (!imgFields) return;

              let HeroImage = imgFields.HeroImage && imgFields.HeroImage.value;
              let igItem = {
                image: {
                  alt: HeroImage && HeroImage.alt,
                  src: HeroImage && HeroImage.src
                },
                items: []
              };
              imgFields.items &&
                imgFields.items.forEach((fld, fldIndex) => {
                  let fldItemField = fld.fields;
                  if (!fldItemField) return;
                  let numberItem = {
                    active:
                      (imgFields.active && imgFields.active.id) === fld.id,
                    coordinates: getCoordinatesPix(
                      fldItemField.coordinates && fldItemField.coordinates.value
                    ),
                    itemBackgroundColor:
                      fldItemField.backgroundColor &&
                      fldItemField.backgroundColor.fields &&
                      fldItemField.backgroundColor.fields.phrase &&
                      fldItemField.backgroundColor.fields.phrase.value,
                    overlineText:
                      fldItemField.overlineText &&
                      fldItemField.overlineText.value,
                    heading: {
                      html: fldItemField.headingBody,
                      type: fldItemField.headingType
                    },
                    subheading: {
                      html: fldItemField.subheadingBody,
                      type: fldItemField.subheadingType
                    },
                    body: fldItemField.body && fldItemField.body.value,
                    button: fldItemField.button && fldItemField.button.fields
                  };
                  igItem.items.push(numberItem);
                });

              multipleOption.images.push(igItem);
            });
          multipleItem.options.push(multipleOption);
        });
      tabMenu.items.push(tabItem);
      multipleHotspotsWithTabMenu.push(multipleItem);
    });

  const singleHotspot = {
    ...overallSettings,
    overlineText: fields.overlineText && fields.overlineText.value,
    image: {
      alt:
        fields.HeroImage &&
        fields.HeroImage.value &&
        fields.HeroImage.value.alt,
      src:
        fields.HeroImage && fields.HeroImage.value && fields.HeroImage.value.src
    },
    items: [],
    ...textContent
  };

  fields.singleItems &&
    fields.singleItems.forEach(item => {
      let itemFields = item.fields;
      if (!itemFields) return;
      let numberItem = {
        active: (fields.active && fields.active.id) === item.id,
        coordinates: getCoordinatesPix(
          itemFields.coordinates && itemFields.coordinates.value
        ),
        itemBackgroundColor:
          itemFields.backgroundColor &&
          itemFields.backgroundColor.fields &&
          itemFields.backgroundColor.fields.phrase &&
          itemFields.backgroundColor.fields.phrase.value,
        overlineText: itemFields.overlineText && itemFields.overlineText.value,
        heading: {
          html: itemFields.headingBody,
          type: itemFields.headingType
        },
        subheading: {
          html: itemFields.subheadingBody,
          type: itemFields.subheadingType
        },
        body: itemFields.body && itemFields.body.value,
        button: itemFields.button && itemFields.button.fields
      };
      singleHotspot.items.push(numberItem);
    });
  return (
    <React.Fragment>
      {multipleHotspotsWithTabMenu.length > 0 && (
        <HotspotWithTabMenu
          {...{
            ...overallSettings,
            tabMenu: tabMenu,
            hotspotCollectionProps: multipleHotspotsWithTabMenu,
            textContent: textContent,
            initialTab: initialTab
          }}
        />
      )}

      {multipleHotspotsWithTabMenu.length <= 0 &&
        singleHotspot.items &&
        singleHotspot.items.length > 0 && (
          <HotspotContainer {...singleHotspot}></HotspotContainer>
        )}
    </React.Fragment>
  );
};

export default Hotspot;
